<h4 mat-dialog-title>Recevabilite pour le dossier #{{ dossier.numeroDossier }}</h4>
<div mat-dialog-content>
  <div class="mb-2 alert alert-light">
    @if (candidat) {
      <strong>{{ candidat.prenom }} {{ candidat.nom | uppercase}}</strong><br>
    }
    <span class="text-muted">{{ dossier.aide['code'] }}</span><br>
    {{ (titreDossier.length > 120) ? (titreDossier | slice:0:120) + '...' : (titreDossier) }}
  </div>

  <ng-container [formGroup]="formRecevabilite">
    <div class="form-group">
      <label for="statut">Statut recevabilité <span class="star">*</span></label>
      <mat-select formControlName="statut" placeholder="Selectionnez" id="statut" class="form-control">
        <mat-option></mat-option>
        @if (dossier.statut !== 5) {
          <mat-option [value]="5">
            Recevable
          </mat-option>
        }
        @if (dossier.statut !== 4) {
          <mat-option [value]="4">
            Non-Recevable
          </mat-option>
        }
      </mat-select>
    </div>

    <div class="form-group">
      <label for="commentaire">
        Commentaire
        @if (formRecevabilite.controls.statut.value && formRecevabilite.controls.statut.value === '4') {
          <span class="star"
          >*</span>
        }
      </label>
      <textarea formControlName="commentaire" id="commentaire" class="form-control"></textarea>
    </div>
  </ng-container>

  @if (formRecevabilite.controls.statut.value && formRecevabilite.controls.statut.value === '4') {
    <div class="mt-2">
      <mat-checkbox [(ngModel)]="nePasEnvoyerMail">&nbsp; Ne pas envoyer de mail</mat-checkbox>
    </div>
  }

</div>
<div mat-dialog-actions>
  <button mat-raised-button (click)="onNoClick()">Annuler</button>
  <button mat-raised-button color="primary" (click)="changerStatut()" [disabled]="formRecevabilite.invalid">
    Valider
  </button>
</div>
